module.exports = __webpack_public_path__ + "static/media/success.cee85b0d.svg";